module.exports = __webpack_public_path__ + "img/gallery9.63f39f6.jpg";